
@if (isReady) {
  <mat-toolbar class="filters">
    <mat-toolbar-row>
      @if (isDisplayed('group')) {
        <mat-form-field>
          <mat-select [formControl]="controls.group"  placeholder="{{ 'graph.select_groups' | translate }}">
            <mat-option></mat-option>
            @for (group of groups; track group) {
              <mat-option [value]="group.groupname">{{ group.groupname }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isDisplayed('workgroup')) {
        <mat-form-field>
          <mat-select [formControl]="controls.workgroup" placeholder="{{ 'graph.select_workgroups' | translate }}">
            <mat-option></mat-option>
            @for (workgroup of workgroups; track workgroup) {
              <mat-option
              [value]="workgroup.workgroupname">{{ workgroup.workgroupname }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if (isDisplayed('learner')) {
        <mat-form-field>
          <label>
            <input type="text"
              [placeholder]="'graph.learner' | translate"
              matInput
              [formControl]="controls.learner"
              [matAutocomplete]="autoLearner">
            </label>
            <mat-autocomplete #autoLearner="matAutocomplete" [displayWith]="displayLearnerFn">
              @for (learner of filteredLearners | async; track learner) {
                <mat-option [value]="learner" >
                  {{learner.nickname}}
                </mat-option>
              }
            </mat-autocomplete>
            @if (controls.learner.hasError('required')) {
              <mat-error>{{ 'graph.progression_required_learner' | translate }}</mat-error>
            }
          </mat-form-field>
        }
        @if (isDisplayed('multiLearner')) {
          <mat-form-field>
            <mat-select [formControl]="controls.multiLearner" placeholder="{{ 'graph.select_learners' | translate }}" multiple>
              @for (learner of filteredByGroupLearners | async; track learner) {
                <mat-option [value]="learner.id">{{learner.nickname}}</mat-option>
              }
            </mat-select>
            @if (controls.multiLearner.hasError('required')) {
              <mat-error>{{ 'graph.progression_required_multiLearner' | translate }}</mat-error>
            }
          </mat-form-field>
        }
        @if (isDisplayed('startDate')) {
          <mat-form-field>
            <!--suppress HtmlFormInputWithoutLabel -->
            <input name="startDate"
              [formControl]="controls.startDate"
              matInput
              [matDatepicker]="startPicker"
              placeholder="{{'generic.beginning_date' | translate}}"
              />
              <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
              <mat-datepicker #startPicker></mat-datepicker>
              @if (controls.startDate.hasError('required')) {
                <mat-error>{{ 'graph.progression_required_startDate' | translate }}</mat-error>
              }
            </mat-form-field>
          }
          @if (isDisplayed('endDate')) {
            <mat-form-field>
              <!--suppress HtmlFormInputWithoutLabel -->
              <input name="endDate"
                [formControl]="controls.endDate"
                matInput
                [matDatepicker]="endPicker"
                placeholder="{{'generic.deadline' | translate}}"
                />
                <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                <mat-datepicker #endPicker></mat-datepicker>
                @if (controls.endDate.hasError('required')) {
                  <mat-error>{{ 'graph.progression_required_endDate' | translate }}</mat-error>
                }
              </mat-form-field>
            }
            @if (isDisplayed('concept')) {
              <mat-form-field>
                <mat-select [formControl]="controls.concept" placeholder="{{ 'graph.progression_concept' | translate }}">
                  @if (isEmptyAllowed('concept')) {
                    <mat-option [value]="">{{ 'graph.progression_none' | translate }}</mat-option>
                  }
                  @for (concept of concepts; track concept) {
                    <mat-option [value]="concept.get('name')">{{ concept.get('name') }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (isDisplayed('educationalLevel')) {
              <mat-form-field>
                <mat-select [formControl]="controls.educationalLevel" placeholder="{{ 'graph.progression_educational_level' | translate }}">
                  @if (isEmptyAllowed('educationalLevel')) {
                    <mat-option [value]="">{{ 'graph.progression_none' | translate }}</mat-option>
                  }
                  @for (educationalLevel of educationalLevels; track educationalLevel) {
                    <mat-option [value]="educationalLevel.get('label')">{{ educationalLevel.get('label') }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (isDisplayed('chapter')) {
              <mat-form-field>
                <mat-select [formControl]="controls.chapter" placeholder="{{ 'graph.progression_exercise_type' | translate }}">
                  @if (isEmptyAllowed('chapter')) {
                    <mat-option [value]="">{{ 'graph.progression_none' | translate }}</mat-option>
                  }
                  @for (chapter of chapters; track chapter) {
                    <mat-option [value]="chapter.get('name')">{{ chapter.get('name') }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (isDisplayed('multiLesson')) {
              <mat-form-field>
                <mat-select [formControl]="controls.multiLesson" placeholder="{{ 'graph.progression_select_lessons' | translate }}" multiple>
                  @for (lesson of lessons; track lesson) {
                    <mat-option [value]="lesson.id">{{lesson.get('metadatas')?.title}}</mat-option>
                  }
                </mat-select>
                @if (controls.multiLesson.hasError('required')) {
                  <mat-error>{{ 'graph.progression_required_lessons' | translate }}</mat-error>
                }
              </mat-form-field>
            }
            @if (isDisplayed('multiSubLesson')) {
              <mat-form-field>
                <mat-select [formControl]="controls.multiSubLesson" placeholder="{{ 'graph.progression_select_sub_lessons' | translate }}" multiple>
                  @for (lesson of subLessons; track lesson) {
                    <mat-option [value]="lesson.id">{{lesson.get('metadatas')?.title}}</mat-option>
                  }
                </mat-select>
                @if (controls.multiSubLesson.hasError('required')) {
                  <mat-error>{{ 'graph.progression_required_sub_lessons' | translate }}</mat-error>
                }
              </mat-form-field>
            }
            @if (couldExpend()) {
              <button (click)="toggle()" class="btn-collapse">
                <span>{{ (barIsExpended ? 'filters.button.collapse' : 'filters.button.expand') | translate }}</span>
                <mat-icon class="collapsable-arrow" [svgIcon]="barIsExpended ? 'keyboard_arrow_down' : 'keyboard_arrow_up'"></mat-icon>
              </button>
            }
          </mat-toolbar-row>
        </mat-toolbar>
      } @else {
        <mat-spinner></mat-spinner>
      }
